import "./Main.css";
import { Link } from "react-router-dom";
import MainPopup from "../Popup/MainPopup";
import { Helmet } from "react-helmet-async";
import HowToPlayPart from "../HowToPlayPart/HowToPlayPart";
import DrawDate from "../DrawDate/DrawDate";
import draws from "../../data/draws";
import NumberContainer from "../NumberContainer/NumberContainer";

const MainCover = () => {
  const lastDraw = draws[0];
  return (
    <>
      <Helmet>
        <title>
          Play the Best Licensed Lottery – Try New Vikinglotto Draws Now
        </title>
        <meta
          name="description"
          content="Discover the best licensed lottery in Europe. New Vikinglotto draws every week, guaranteed fairness, and real chances to win across all participating countries."
        />
        <link rel="canonical" href="https://lottolegenda.com/" />
      </Helmet>
      <main className="lottolegenda-main">
        {/* <MainPopup/> */}
        <section className="lottolegenda-main__cover">
          <div className="lottolegenda-main__body pad">
            <div className="lottolegenda-main__text">
              <h1 className="lottolegenda-main__header col-white">
                Europe’s Original Lottery Since 1993
              </h1>
              <div className="lottolegenda-main__grid">
                <div className="lottolegenda-main__grid-part lottolegenda-main__grid-part-1">
                  <p className="col-white">Jackpot</p>
                  <p className="fw-700">€25,000,000</p>
                </div>
                <div className="lottolegenda-main__grid-part lottolegenda-main__grid-part-2">
                  <p className="col-white">Next Draw</p>
                  <DrawDate />
                </div>
              </div>
              <Link to="/results" className="lottolegenda-main__link">
                Check Latest Numbers
              </Link>
            </div>
            <div className="lottolegenda-main__img"></div>
          </div>
        </section>
        <HowToPlayPart />
        <section className="pad pad-top flex lottolegenda-latest">
          <h2 className="text-center">Latest Results</h2>
          <div className="lottolegenda-latest__container line">
            <div className="lottolegenda-latest__part">
              <p className="t-12">Last Draw Date</p>
              <p>Wednesday, {lastDraw.date}</p>
            </div>
            <div className="lottolegenda-latest__part">
              <p className="t-12">Winning Numbers</p>
              <div className="lottolegenda-draws__container">
                {lastDraw.winningNumbers.map((i) => (
                  <NumberContainer key={i} color={"blue"} number={i} />
                ))}
              </div>
            </div>
            <div className="lottolegenda-latest__part">
              <p className="t-12">Viking Number</p>
              <NumberContainer
                color={"yellow"}
                number={lastDraw.vikingNumber}
              />
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default MainCover;
